import React from 'react'

export default function DeleteImg() {
  return (
    <svg width="21" height="23" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.95764 5.55078H3.95764H19.9576" stroke="#D62D20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17.9576 5.55078V19.5508C17.9576 20.0812 17.7469 20.5899 17.3719 20.965C16.9968 21.3401 16.4881 21.5508 15.9576 21.5508H5.95764C5.42721 21.5508 4.9185 21.3401 4.54343 20.965C4.16836 20.5899 3.95764 20.0812 3.95764 19.5508V5.55078M6.95764 5.55078V3.55078C6.95764 3.02035 7.16836 2.51164 7.54343 2.13657C7.9185 1.76149 8.42721 1.55078 8.95764 1.55078H12.9576C13.4881 1.55078 13.9968 1.76149 14.3719 2.13657C14.7469 2.51164 14.9576 3.02035 14.9576 3.55078V5.55078" stroke="#D62D20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.95764 10.5508V16.5508" stroke="#D62D20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.9576 10.5508V16.5508" stroke="#D62D20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>    
  )
}
